import React, { Component } from 'react'

import ReactHtmlParser from 'react-html-parser'
import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';
import { connect } from 'react-redux'
import { getTerm } from '../../../../redux/auth/actions'
import { utils } from '../../../../database'

class Terms extends Component {
  constructor (props) {
    super(props)
    this.outerDiv = React.createRef()
  }

  reportHeight() {
    if (this.props.onHeight && this.outerDiv.current) {
      const height = this.outerDiv.current.clientHeight
      if (height > 0) {
        this.props.onHeight(height)
      }
    }
  }

  componentDidMount () {
    this.reportHeight()
  }

  componentDidUpdate (prevProps) {
    if (this.props.conteudo !== prevProps.conteudo ||
        this.props.localData !== prevProps.localData) {
      requestAnimationFrame(() => this.reportHeight())
    }
  }

  render () {
    return (
      <div ref={this.outerDiv} style={{ fontFamily: 'Helvetica' }}>
        {ReactHtmlParser(this.props.conteudo || this.props.localData)}
      </div>
    )
  }
}

const propsFromDatabase = async props => {
  const remoteData = await props.requestTerm(props.type)
  const storedData = await utils.getFromLocalStorage(props.name)
  const localVersion = !isEmpty(storedData) ? JSON.parse(storedData) : {}
  const remoteVersion = !isEmpty(remoteData)
    ? pick(remoteData, ['conteudo', 'versao'])
    : {}
  return {
    ...localVersion,
    ...remoteVersion
  }
}

const mapDispatchToProps = dispatch => ({
  requestTerm: async type => dispatch(getTerm(type))
})

export default connect(
  null,
  mapDispatchToProps
)(utils.withPropsFromDatabase(propsFromDatabase, Terms))
